export const SPECIALTY_ROUTE_NAME = 'specialties';

export const SPECIALTY_ROUTES = {
  get: '/specialties/{specialtyBoardId}',
};
